export default __webpack_public_path__ + "static/hero-da0dd672d4ea6f9dc088ad7ec6b5bd7f.png";